module.exports = __webpack_public_path__ + "img/6519.0e542d60.jpg";